import React, { useEffect, useState } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import zap from 'common/modules/zap';
import { RpuPeriods, ZapForm } from 'common/modules/zap/components';

import * as afterSalesSettingsSelectors from '../../afterSalesSettings/selectors';
import * as actions from '../actions';
import { UPLOAD_ORIGINS } from '../constants';
import * as selectors from '../selectors';

const ZapRpuPeriodsModal = ({
    cfeUser,
    getValues,
    handleIntegrationsInfo,
    isOpen,
    isSearching,
    searchZapRpu,
    serviceNumber,
    setIsOpen,
    zapRpuId,
}) => {
    const [temporaryRpuId, setTemporaryRpuId] = useState(null);
    const [currentZapRpuId, setCurrentZapRpuId] = useState(zapRpuId);
    const { t } = useTranslation();

    useEffect(() => {
        setCurrentZapRpuId(zapRpuId);
    }, [zapRpuId]);

    const handleOnClose = () => setIsOpen(false);

    const onChangeTemporalRpuId = (rpu) => setTemporaryRpuId(rpu?.id);

    const onSubmit = (period) => {
        handleIntegrationsInfo({
            data: period,
            file: period?.url,
            finalDate: period?.final_date,
            getValues,
            initialDate: period?.initial_date,
            uploadOrigin: UPLOAD_ORIGINS.ZAP,
        });
        handleOnClose();
    };

    return (
        <>
            <Dialog
                onClose={handleOnClose}
                open={isOpen}
                size="md"
                title={t(currentZapRpuId ? 'Select period' : 'Search')}
            >
                {currentZapRpuId ? (
                    <RpuPeriods
                        onCancel={handleOnClose}
                        onSubmit={onSubmit}
                        rpuId={currentZapRpuId}
                        submitText={t('Continue')}
                    />
                ) : (
                    <ZapForm
                        addRpu={(values) =>
                            searchZapRpu(values, onChangeTemporalRpuId)
                        }
                        hiddenFields={['rpu_id']}
                        initialValues={{
                            cfe_user: cfeUser || '',
                            service_number: serviceNumber || '',
                        }}
                        isLoading={isSearching}
                        variant="standard"
                        onCancel={handleOnClose}
                    />
                )}

                <zap.Container
                    entity="rpu"
                    entityId={temporaryRpuId}
                    onFinished={() => setCurrentZapRpuId(temporaryRpuId)}
                />
            </Dialog>
        </>
    );
};

ZapRpuPeriodsModal.propTypes = {
    cfeUser: PropTypes.string,
    getValues: PropTypes.func,
    handleIntegrationsInfo: PropTypes.func,
    isOpen: PropTypes.bool,
    isSearching: PropTypes.bool,
    searchZapRpu: PropTypes.func,
    serviceNumber: PropTypes.string,
    setIsOpen: PropTypes.func,
    zapRpuId: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
    cfeUser: afterSalesSettingsSelectors.getCustomerConsumptionName,
    isOpen: selectors.getIsZapRpuPeriodsModalOpen,
    isSearching: selectors.getIsSearchingZapRpu,
    serviceNumber: afterSalesSettingsSelectors.getAfterSalesServiceNumber,
    zapRpuId: afterSalesSettingsSelectors.getAfterSalesSettingsZapRpuId,
});

const mapDispatchToProps = (dispatch) => ({
    handleIntegrationsInfo: (props) =>
        dispatch(actions.handleIntegrationsInfo(props)),
    searchZapRpu: (values, onSuccess) =>
        dispatch(actions.searchZapRpu(values, onSuccess)),
    setIsOpen: (isOpen) =>
        dispatch(actions.setZapRpuPeriodsModalOpenStatus(isOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZapRpuPeriodsModal);
